import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function EditorPicks() {
  const gossip = articles.filter((item) => item.category === "gossip");
  const depth = articles.filter((item) => item.category === "depth" || item.category === "exclusive");

  return (
    <section aria-labelledby="picks-title" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="mb-7 border-b border-background-200 pb-4">
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            编辑推荐
          </p>
          <h2 id="picks-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            两个读法：读细节，或者读逻辑
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-chat-smile-2-line" aria-hidden="true" />
                </span>
                微八卦
              </h3>
              <span className="text-xs text-secondary-600">从细节读行业</span>
            </div>
            <div>
              {gossip.map((item, index) => (
                <ArticleCard key={item.id} article={item} variant="compact" index={index} />
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-article-line" aria-hidden="true" />
                </span>
                深度长文
              </h3>
              <span className="text-xs text-secondary-600">慢下来阅读</span>
            </div>
            <div>
              {depth.map((item, index) => (
                <ArticleCard key={item.id} article={item} variant="compact" index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}